import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import {
  HandshakeOutlined,
  LockOutlined,
  TaskAltOutlined,
  TipsAndUpdatesOutlined,
} from "@mui/icons-material";

import { RoutePaths } from "src/app/model";
import { handleBookCall } from "src/shared/utils";

export const AboutUsPage: React.FC = () => {
  return (
    <Stack
      id={RoutePaths.ABOUT_US}
      width={1}
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={4}
      sx={{
        scrollMarginTop: 80,
      }}
    >
      <Typography
        color="text.secondary"
        variant="h5"
        fontWeight="light"
        textTransform="uppercase"
        sx={{
          fontSize: { sm: "1.5rem", xs: "1rem" },
        }}
      >
        About Us
      </Typography>

      <Stack
        width={1}
        direction="row"
        gap={8}
        sx={{
          flexDirection: { md: "row", xs: "column" },
        }}
      >
        <Stack
          width={1}
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          gap={2}
          sx={{
            alignItems: { md: "flex-start", xs: "center" },
          }}
        >
          <Stack direction="row" gap={1}>
            <Typography
              color="text.secondary"
              variant="h4"
              fontWeight={300}
              sx={{
                fontSize: {
                  md: "2.125rem",
                  xs: "2rem",
                },
              }}
            >
              OUR
            </Typography>
            <Typography
              color="primary"
              variant="h4"
              fontWeight={300}
              sx={{
                fontSize: {
                  md: "2.125rem",
                  xs: "2rem",
                },
              }}
            >
              MISSION
            </Typography>
          </Stack>

          <Typography
            width={0.8}
            color="text.primary"
            variant="body1"
            textAlign="start"
            sx={{
              textAlign: { md: "start", xs: "center" },
            }}
          >
            To serve as a strategic catalyst, empowering Germany's leading
            companies to conquer their most complex AI roadblocks through rapid,
            collaborative innovation, securing their long-term competitive edge
            and technological independence.
          </Typography>

          <Button
            variant="outlined"
            onClick={handleBookCall}
            sx={{
              textTransform: "none",
            }}
          >
            Book a Call
          </Button>
        </Stack>

        <Stack
          width={1}
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          gap={2}
          sx={{
            alignItems: { md: "flex-start", xs: "center" },
          }}
        >
          <Stack direction="row" gap={1}>
            <Typography
              color="text.secondary"
              variant="h4"
              fontWeight={300}
              sx={{
                fontSize: {
                  sm: "2.125rem",
                  xs: "2rem",
                },
              }}
            >
              OUR
            </Typography>
            <Typography
              color="primary"
              variant="h4"
              fontWeight={300}
              sx={{
                fontSize: {
                  sm: "2.125rem",
                  xs: "2rem",
                },
              }}
            >
              VALUES
            </Typography>
          </Stack>

          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            gap={2}
            sx={{
              flexDirection: { md: "row", xs: "column" },
            }}
          >
            <TipsAndUpdatesOutlined color="primary" fontSize="large" />

            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              sx={{
                alignItems: { md: "flex-start", xs: "center" },
              }}
            >
              <Typography color="text.secondary" variant="h6">
                Deep Expertise
              </Typography>
              <Typography
                color="text.primary"
                variant="body2"
                sx={{
                  textAlign: { md: "start", xs: "center" },
                }}
              >
                Solutions are grounded in fundamental scientific principles.
              </Typography>
            </Stack>
          </Stack>

          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            gap={2}
            sx={{
              flexDirection: { md: "row", xs: "column" },
            }}
          >
            <TaskAltOutlined color="primary" fontSize="large" />

            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              sx={{
                alignItems: { md: "flex-start", xs: "center" },
              }}
            >
              <Typography color="text.secondary" variant="h6">
                Tangible Results
              </Typography>
              <Typography
                color="text.primary"
                variant="body2"
                sx={{
                  textAlign: { md: "start", xs: "center" },
                }}
              >
                A focus on functional prototypes over theoretical slide decks to
                prove value and build momentum.
              </Typography>
            </Stack>
          </Stack>

          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            gap={2}
            sx={{
              flexDirection: { md: "row", xs: "column" },
            }}
          >
            <HandshakeOutlined color="primary" fontSize="large" />

            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              sx={{
                alignItems: { md: "flex-start", xs: "center" },
              }}
            >
              <Typography color="text.secondary" variant="h6">
                Client Empowerment
              </Typography>
              <Typography
                color="text.primary"
                variant="body2"
                sx={{
                  textAlign: { md: "start", xs: "center" },
                }}
              >
                Building robust, maintainable solutions that the client's team
                can own and operate, preventing vendor lock-in. ToDo: utilizing
                active communictation with cleints employees for product
                development (this idea better formulated).
              </Typography>
            </Stack>
          </Stack>

          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            gap={2}
            sx={{
              flexDirection: { md: "row", xs: "column" },
            }}
          >
            <LockOutlined color="primary" fontSize="large" />

            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              sx={{
                alignItems: { md: "flex-start", xs: "center" },
              }}
            >
              <Typography color="text.secondary" variant="h6">
                Principled Execution
              </Typography>
              <Typography
                color="text.primary"
                variant="body2"
                sx={{
                  textAlign: { md: "start", xs: "center" },
                }}
              >
                Upholding the highest standards of business ethics, including
                data privacy and employee consideration.
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
